import metaOverview from "../../../../assets/images/docs/meta/meta-overview.png";
import missingtags from "../../../../assets/images/docs/meta/missingtags.png";
import * as React from 'react';
export default {
  metaOverview,
  missingtags,
  React
};